import {Button, Dropdown, DropdownButton, Pagination, Stack} from "react-bootstrap";
import {DOTS, usePagination2} from "../../hooks";
import React from "react";

export function OurPagination({loading, pageIndex, pageSize, pages, onPageChange}) {

    const label = "Items per page"
    const pageOptions = [10, 25, 50, 100]

    const onNext = () => onPageChange(pageIndex + 1, pageSize)
    const onPrevious = () => onPageChange(pageIndex - 1, pageSize)

    const onSizeChange = ek => {
        onPageChange(0, Number(ek))
    }

    return <Stack direction="horizontal" gap={3} className="justify-content-center justify-content-md-end mt-3">
        {pages && <Pagination className="mt-3">
            {(pages.length > 1 && pages[1] === DOTS) && <Pagination.Prev onClick={onPrevious}/>}
            {pages.map((page, i) => (
                <Pagination.Item key={i}
                                 active={(page === pageIndex + 1)}
                                 disabled={(page === DOTS) || loading}
                                 onClick={() => onPageChange(page - 1, pageSize)}>{page}</Pagination.Item>
            ))}
            {(pages[pages.length - 2] === DOTS) && <Pagination.Next onClick={onNext}/>}
        </Pagination>}

        <Dropdown onSelect={onSizeChange} className="flex-shrink-0" disabled={loading}>
            <Dropdown.Toggle variant="primary" id="paginationId">
                {label} {pageSize}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {pageOptions.map(o => <Dropdown.Item as={Button} key={o} eventKey={o} active={o === pageSize}>{label} {o}</Dropdown.Item>)}
            </Dropdown.Menu>
        </Dropdown>
    </Stack>
}

export function OurPagination2({loading, itemCount}) {

    const label = "Items per page"
    const pageOptions = [10, 25, 50, 100]

    const [pages, pageIndex, pageSize, onPageChange] = usePagination2(itemCount)

    const onNext = () => onPageChange(pageIndex + 1, pageSize)
    const onPrevious = () => onPageChange(pageIndex - 1, pageSize)

    const onSizeChange = ek => {
        onPageChange(0, Number(ek))
    }

    return <Stack direction="horizontal" gap={3} className="justify-content-center justify-content-md-end mt-3">
        {pages && <Pagination className="mt-3">
            {(pages.length > 1 && pages[1] === DOTS) && <Pagination.Prev onClick={onPrevious}/>}
            {pages.map((page, i) => (
                <Pagination.Item key={i}
                                 active={(page === pageIndex + 1)}
                                 disabled={(page === DOTS) || loading}
                                 onClick={() => onPageChange(page - 1, pageSize)}>{page}</Pagination.Item>
            ))}
            {(pages[pages.length - 2] === DOTS) && <Pagination.Next onClick={onNext}/>}
        </Pagination>}

        <DropdownButton onSelect={onSizeChange} className="flex-shrink-0" disabled={loading} title={`${label} ${pageSize}`}>
            {pageOptions.map(o => <Dropdown.Item as={Button} key={o} eventKey={o} active={o === pageSize}>{label} {o}</Dropdown.Item>)}
        </DropdownButton>
    </Stack>
}
